var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGem = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1.531 5.351a.59.59 0 0 0 .09.548l5.906 7.865a.591.591 0 0 0 .946 0l5.906-7.866a.625.625 0 0 0 .08-.14.59.59 0 0 0-.045-.524l-1.77-2.947A.591.591 0 0 0 12.135 2H3.864c-.208 0-.4.109-.507.287L1.586 5.234a.592.592 0 0 0-.055.117Zm8.11-.4H6.284l.414-1.77H9.05l.59 1.77Zm.017 1.18H6.342L8 11.43 9.658 6.13Zm-.07 4.18 1.308-4.18h1.831l-3.139 4.18Zm1.3-5.36-.591-1.77h1.505l1.063 1.77h-1.978ZM5.482 3.18l-.414 1.77H3.135l1.063-1.77h1.285Zm.929 7.13-1.308-4.18H3.273l3.139 4.18Z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGem);
export default ForwardRef;